<!--
 * @Author: Junjie
 * @Date: 2024-08-12 13:56:18
 * @LastEditTime: 2024-08-12 14:49:46
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-wf-web/src/views/wf/WfConsumerCorpPermissionList.vue
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-model-item label="供水流域">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.dev_process,process_name,id, del_flag = '0' order by sort"
                placeholder="请选择供水流域"
                v-model="queryParam.devProcessId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="表号">
              <a-input placeholder="请输入表号" v-debounce="searchQuery" v-model="queryParam.devTag"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :md="3" :sm="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" @keyup.enter.native="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <template slot="pcaSlot" slot-scope="text">
          <div>{{ getPcaText(text) }}</div>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="recharge(record)">充水量</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { httpAction, getAction } from '@/api/manage'
  import Area from '@/components/_util/Area'

  export default {
    name: 'WfDevPermissionList',
    mixins: [JeecgListMixin, mixinDevice],
    props: {
      model: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {
        ipagination: {
          pageSize: 50,
        },
        // 表头
        columns: [
          {
            title: '设备名称',
            align: 'center',
            dataIndex: 'devName',
            sorter: true
          },
          {
            title: '表号',
            align: 'center',
            dataIndex: 'devTag',
            scopedSlots: { customRender: 'devTagSlot' },
            sorter: true
          },
          {
            title: '区域',
            align: 'center',
            dataIndex: 'region',
            sorter: true,
            scopedSlots: { customRender: 'pcaSlot' }
          },
          {
            title: '安装位置',
            align: 'left',
            dataIndex: 'location',
            scopedSlots: { customRender: 'locationSlot' },
            sorter: true
          }
        ],
        url: {
          list: '/device/devList/listNotInIds',
          auzEdit: "/wf/wfConsumerCorp/auzEdit",
        },
        dictOptions: {},
        superFieldList: [],
        authDevs: [],
        pcaData: '',
        disableMixinCreated: true,
      }
    },
    created () {
      this.pcaData = new Area()
      this.$set(this.dictOptions, 'disabled', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.getSuperFieldList();
      if (this.model.authDevs && this.model.authDevs.length) {
        this.queryParam.id = this.model.authDevs.join(',');
      }
      this.loadData();
    },
    methods: {
      submitForm () {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
          return;
        }
        const that = this;
        // 找出新增的元素
        const added = this.selectedRowKeys.map(item => ({
          devId: item,
          corpId: that.model.id
        }));

        httpAction(this.url.auzEdit, {
          added
        }, 'put').then(res => {
          if (res.success) {
            this.$message.success('授权成功')
            this.$emit('ok');
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getPcaText (code) {
        return this.pcaData.getText(code);
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'corpName', text: '企业名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'contact', text: '联系人', dictCode: '' })
        fieldList.push({ type: 'string', value: 'phone', text: '联系电话', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'contractVolume', text: '合同用水量(吨)', dictCode: '' })
        fieldList.push({ type: 'int', value: 'contractCycle', text: '合同周期', dictCode: '' })
        fieldList.push({ type: 'string', value: 'contractCycleUnit', text: '合同周期单位', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'remainingVolume', text: '剩余可用量', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'overUsage', text: '允许超用量', dictCode: '' })
        fieldList.push({ type: 'date', value: 'joinTime', text: '加入时间' })
        fieldList.push({ type: 'switch', value: 'disabled', text: '禁止取水' })
        fieldList.push({ type: 'string', value: 'remark', text: '备注', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>